import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
declare var createUnityInstance: any;

@Component({
  selector: 'app-digital-twin',
  templateUrl: './digital-twin.component.html',
  styleUrls: ['./digital-twin.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DigitalTwinComponent implements OnInit, AfterViewInit, OnDestroy {
  unityInstance: any;
  constructor() { }

  ngOnInit(): void {
  }

  async ngAfterViewInit() {
    this.loadDigitalTwin();
  }

  // private async loadDigitalTwin() {
  //   let canvas = document.querySelector("#unity-canvas") as HTMLElement;
  //   // Shows a temporary message banner/ribbon for a few seconds, or
  //   // a permanent error message on top of the canvas if type=='error'.
  //   // If type=='warning', a yellow highlight color is used.
  //   // Modify or remove this function to customize the visually presented
  //   // way that non-critical warnings and error messages are presented to the
  //   // user.
  //   function unityShowBanner(msg, type) {
  //     var warningBanner = document.querySelector("#unity-warning") as HTMLElement;
  //     function updateBannerVisibility() {
  //       warningBanner.style.display = warningBanner.children.length ? 'block' : 'none';
  //     }
  //     var div = document.createElement<any>('div');
  //     div.innerHTML = msg;
  //     warningBanner.appendChild(div);
  //     if (type == 'error') div.style = 'background: red; padding: 10px;';
  //     else {
  //       if (type == 'warning') div.style = 'background: yellow; padding: 10px;';
  //       setTimeout(function () {
  //         warningBanner.removeChild(div);
  //         updateBannerVisibility();
  //       }, 5000);
  //     }
  //     updateBannerVisibility();
  //   }

  //   var buildUrl = "../../../../../assets/unity/Build";
  //   var loaderUrl = buildUrl + "/V15.loader.js";
  //   var config = {
  //     arguments: [],
  //     dataUrl: buildUrl + "/V15.data",
  //     frameworkUrl: buildUrl + "/V15.framework.js",
  //     codeUrl: buildUrl + "/V15.wasm",
  //     streamingAssetsUrl: "StreamingAssets",
  //     companyName: "DefaultCompany",
  //     productName: "HUMMER EV - V2",
  //     productVersion: "0.1.0",
  //     showBanner: unityShowBanner,
  //   };

  //   // By default, Unity keeps WebGL canvas render target size matched with
  //   // the DOM size of the canvas element (scaled by window.devicePixelRatio)
  //   // Set this to false if you want to decouple this synchronization from
  //   // happening inside the engine, and you would instead like to size up
  //   // the canvas DOM size and WebGL render target sizes yourself.
  //   // config.matchWebGLToCanvasSize = false;

  //   document.querySelector<HTMLElement>("#unity-loading-bar").style.display = "block";

  //   let script = document.createElement("script");
  //   script.src = loaderUrl;
  //   script.onload = () => {
  //     createUnityInstance(canvas, config, (progress) => {
  //       document.querySelector<HTMLElement>("#unity-progress-bar-full").style.width = 100 * progress + "%";
  //       document.querySelector<HTMLElement>("#unity-loading-bar").style.left = 60 + "%";
  //     }).then((unityInstance) => {
  //       this.unityInstance = unityInstance;
  //       document.querySelector<HTMLElement>("#unity-loading-bar").style.display = "none";
  //       document.querySelector<HTMLElement>("#unity-fullscreen-button").onclick = () => {
  //         unityInstance.SetFullscreen(1);
  //       };

  //     }).catch((message) => {
  //       // alert(message);
  //     });
  //   };
  //   document.body.appendChild(script);
  // }

  private loadDigitalTwin() {
    var buildUrl = "../../../../../assets/unity/Build";
    var config = {
      arguments: [],
      dataUrl: buildUrl + "/V15.data",
      frameworkUrl: buildUrl + "/V15.framework.js",
      codeUrl: buildUrl + "/V15.wasm",
      streamingAssetsUrl: "StreamingAssets",
      companyName: "DefaultCompany",
      productName: "HUMMER EV - V2",
      productVersion: "0.1.0",
      showBanner: this.unityShowBanner,
    };

    var canvas: HTMLElement = document.querySelector("#unity-canvas") || new HTMLElement();
    var loadingBar: HTMLElement = document.querySelector("#unity-loading-bar") || new HTMLElement();
    var progressBarFull: HTMLElement = document.querySelector("#unity-progress-bar-full") || new HTMLElement();

    loadingBar.style.display = "block";
    createUnityInstance(canvas, config, (progress: any) => {
      progressBarFull.style.width = 100 * progress + "%";
      loadingBar.style.left = 60 + "%";
    }).then((unityInstance: any) => {
      this.unityInstance = unityInstance;
      loadingBar.style.display = "none";
      document.querySelector<HTMLElement>("#unity-fullscreen-button").onclick = () => {
        unityInstance.SetFullscreen(1);
      };
    }).catch((message) => {
      // alert(message);
    });
  }

  unityShowBanner(msg, type) {
    var warningBanner = document.querySelector("#unity-warning") as HTMLElement;
    function updateBannerVisibility() {
      warningBanner.style.display = warningBanner.children.length ? 'block' : 'none';
    }
    var div = document.createElement<any>('div');
    div.innerHTML = msg;
    warningBanner.appendChild(div);
    if (type == 'error') div.style = 'background: red; padding: 10px;';
    else {
      if (type == 'warning') div.style = 'background: yellow; padding: 10px;';
      setTimeout(() => {
        warningBanner.removeChild(div);
        updateBannerVisibility();
      }, 5000);
    }
    updateBannerVisibility();
  }

  ngOnDestroy(): void {
    this.unityInstance.Quit();
  }
}
